export default __webpack_public_path__ + "media/images/theme/m_logo_dark-3689d6dc30fd223c13fa81384cf22e52.png";